// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBkuZTtYT_Kk0v50TCjJn0oV25hykAoQpA",
  authDomain: "foodorderapp-2b2df.firebaseapp.com",
  projectId: "foodorderapp-2b2df",
  storageBucket: "foodorderapp-2b2df.appspot.com",
  messagingSenderId: "255365039854",
  appId: "1:255365039854:web:da178754d3b0450f6315ff",
  databaseURL: "https://foodorderapp-2b2df-default-rtdb.europe-west1.firebasedatabase.app"
};

// Local testing against the Firebase emulators (npm run dev:emulators):
// a throwaway "demo-" project, so nothing reaches the real database.
const useEmulators = import.meta.env.VITE_USE_EMULATORS === "true";
if (useEmulators) firebaseConfig.projectId = "demo-pos";

// Initialize Firebase
// Realtime Database and Messaging are no longer started here: every page,
// including each restaurant's public site, loaded them although only one admin
// screen uses the database and nothing uses messaging (17 October 2026 review:
// the menu took 5 s to appear). useDeliveryLocations.js starts the database itself.
export const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();
googleAuthProvider.setCustomParameters({ prompt: 'select_account' });
// Offline cache: the POS keeps selling when the internet drops, and writes
// sync when it is back. Falls back to the default memory cache when the browser
// has no IndexedDB (private mode on some browsers).
function createDb() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
    });
  } catch (e) {
    console.warn("[firebase] offline cache unavailable", e);
    return getFirestore(app);
  }
}
export const db = createDb();

/** Must match `region` on `sendPushToTopic` in functions/index.js (default us-central1). */
const functionsRegion = import.meta.env.VITE_FUNCTIONS_REGION || "us-central1";
export const functions = getFunctions(app, functionsRegion);

/** sendOrderStatusNotification — europe-west1 (مطابقة للنشر في Console) */
const functionsEuropeWest1 = getFunctions(app, "europe-west1");

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectFunctionsEmulator(functionsEuropeWest1, "127.0.0.1", 5001);
}

/**
 * Send FCM to a topic via Cloud Function `sendPushToTopic` (firebase-admin messaging).
 */
export const sendNotificationToTopic = async (topic, title, body) => {
  const send = httpsCallable(functions, "sendPushToTopic");
  try {
    const res = await send({
      topic: String(topic || "").trim(),
      title: String(title || "").trim(),
      body: String(body || "").trim()
    });
    return res.data || { success: true };
  } catch (error) {
    const details = error?.details
    const msg =
      (typeof details === 'string' && details) ||
      error?.message ||
      (typeof error?.code === 'string' ? error.code : '') ||
      String(error)
    console.error('Error sending notification:', error)
    throw new Error(msg)
  }
};

/**
 * إشعار تغيير حالة الطلب للعميل (FCM token مباشر).
 * Cloud Function: sendOrderStatusNotification @ europe-west1
 */
export const sendOrderStatusNotificationCallable = async ({
  fcmToken,
  orderId,
  orderSource = 'orders',
  newStatus,
  newStatusLabel = '',
  updatedBy = '',
  title = 'تحديث حالة الطلب',
  body = ''
}) => {
  const send = httpsCallable(functionsEuropeWest1, 'sendOrderStatusNotification')
  try {
    const res = await send({
      fcmToken: String(fcmToken || '').trim(),
      orderId: String(orderId || '').trim(),
      orderSource: String(orderSource || 'orders').trim(),
      newStatus: String(newStatus || '').trim(),
      newStatusLabel: String(newStatusLabel || '').trim(),
      updatedBy: String(updatedBy || '').trim(),
      title: String(title || 'تحديث حالة الطلب').trim(),
      body: String(body || '').trim()
    })
    return res.data || { success: true }
  } catch (error) {
    const details = error?.details
    const msg =
      (typeof details === 'string' && details) ||
      error?.message ||
      (typeof error?.code === 'string' ? error.code : '') ||
      String(error)
    console.error('Error sending order status notification:', error)
    throw new Error(msg)
  }
}
